<template>
  <div class="container containerForm">
    <h2 style="text-align: center">تعديل بيانات مستخدم</h2>
    <form>
      <div class="form-group">
        <label for="firstName">الاسم الأول</label>
        <input
          type="text"
          class="form-control"
          id="firstName"
          v-model="editedUser.firstName"
        />
      </div>
      <div class="form-group">
        <label for="lastName">الاسم الأخير</label>
        <input
          type="text"
          class="form-control"
          id="lastName"
          v-model="editedUser.lastName"
        />
      </div>
      <div class="form-group">
        <label for="email">البريد الإلكتروني</label>
        <input
          type="text"
          class="form-control"
          id="email"
          v-model="editedUser.email"
        />
      </div>
      <div class="form-group">
        <label for="role">الدور</label>
        <select class="form-control" id="role" v-model="editedUser.role">
          <option value="" disabled selected>اختر الدور</option>
          <option value="ادمن">ادمن</option>
          <option value="موظف">موظف</option>
        </select>
      </div>
      <div class="form-group">
        <label for="phoneNumber">رقم الهاتف </label>
        <input
          type="text"
          class="form-control"
          id="phoneNumber"
          v-model="editedUser.phoneNumber"
        />
      </div>
      <div class="form-group">
        <label for="password">كلمة المرور</label>
        <input
          type="password"
          class="form-control"
          id="password"
          v-model="editedUser.password"
        />
      </div>
      <div class="form-group">
        <label for="image">صورة المستخدم</label>
        <input
          type="file"
          accept="image/*"
          class="form-control"
          id="image"
          @change="handleImageChange"
        />
      </div>
      <button type="submit" class="btn btn-primary" @click.prevent="updateUser">
        حفظ
      </button>
    </form>
  </div>
</template>

<script>
import Axios from "../../../Axios";

export default {
  data() {
    return {
      editedUser: {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        password: "",
        role: "",
        image: "",
      },
    };
  },

  methods: {
    updateUser() {
      for (const key in this.userData) {
        if (!this.userData[key]) {
          this.$iziToast.error({
            timeout: 2000,
            message: "الرجاء ملء جميع الحقول المطلوبة",
            position: "bottomRight",
          });
          return;
        }
      }
      const id = this.$route.params.id;
      const { firstName, lastName, role, phoneNumber, password, email, image } =
        this.editedUser;

      // Fetch the current user details first
      Axios
        .get(`/user/${id}`)
        .then((response) => {
          const currentUser = response.data;

          const updatedFields = {};

          updatedFields.firstName = firstName;
          updatedFields.lastName = lastName;
          updatedFields.role = role;
          updatedFields.image = image;
          updatedFields.password = password;
          if (email !== currentUser.email) {
            updatedFields.email = email;
          }

          if (phoneNumber !== currentUser.phoneNumber) {
            updatedFields.phoneNumber = phoneNumber;
          }
          // console.log("updatedFields", updatedFields);
          // Make the patch request with updated fields
          Axios
            .patch(`/user/${id}`, updatedFields, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              this.$iziToast.success({
                timeout: 2000,
                message: "تم التحديث بنجاح",
                position: "bottomRight",
              });
              this.$router.push("/admin/users");
            })
            .catch((error) => {
              // console.log(error.response.data);
              if (error.response && error.response.data) {
                const errorMessage = error.response.data.message;
                this.$iziToast.error({
                  timeout: 5000,
                  message: errorMessage,
                  position: "bottomRight",
                });
              } else {
                this.$iziToast.error({
                  timeout: 2000,
                  message: "فشل الإضافة",
                  position: "bottomRight",
                });
              }
            });
        })
        .catch((error) => {
          // console.error(error);
          if (error.response && error.response.data) {
                const errorMessage = error.response.data.message;
                this.$iziToast.error({
                  timeout: 5000,
                  message: errorMessage,
                  position: "bottomRight",
                });
              } else {
                this.$iziToast.error({
                  timeout: 2000,
                  message: "فشل الإضافة",
                  position: "bottomRight",
                });
              }
        });
    },
    handleImageChange(event) {
      const selectedImage = event.target.files[0];
      if (selectedImage) {
        // Set the selected image to userData.image
        this.editedUser.image = selectedImage;
      }
    },
    fetchUserDetails() {
      const id = this.$route.params.id;
      Axios
        .get("/user/" + id)
        .then((response) => {
          this.editedUser = response.data;
          // console.log(this.editedUser);
        })
        .catch((error) => {
          // console.error(error);
        });
    },
  },
  mounted() {
    this.fetchUserDetails();
  },
};
</script>
